module.exports = __webpack_public_path__ + "img/fabric_stretch.f246a427.png";